import { Button } from 'antd';
import styled from 'styled-components';
import { GreenColors, NeutralColors } from 'theme';

export const FifoModalContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FifoModalSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FifoModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 0;
`;

export const FifoModalButton = styled(Button)`
  height: 40px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.105px;
  padding: 10px 16px;
`;

export const FifoModalPrimaryButton = styled(FifoModalButton)`
  background-color: ${GreenColors[60]} !important;
  border: none !important;
  color: ${NeutralColors[0]} !important;

  &:hover {
    background-color: ${GreenColors[70]} !important;
  }

  &:active {
    background-color: ${GreenColors[80]} !important;
  }
`;

export const FifoModalSecondaryButton = styled(FifoModalButton)`
  background-color: ${NeutralColors[0]} !important;
  border: 1px solid ${NeutralColors[30]} !important;
  color: ${NeutralColors[100]} !important;

  &:hover {
    border-color: ${NeutralColors[40]} !important;
    color: ${NeutralColors[100]} !important;
  }
`;
